import { LwApiPM } from "@techniaorg/liteweb-api";
import { modelPathOnServer, waitForIFrame } from "../src/util";

// Wait until the iframe is loaded
const myframe = document.querySelector("iframe#webviewer") as HTMLIFrameElement;
let LwAPI: LwApiPM | null = null;
const apiReady: Promise<LwApiPM | null> = waitForIFrame(myframe)
  .then((api) => {
    LwAPI = api;
    LwAPI?.registerOnSelection(function (selectedItem) {
      console.log(
        selectedItem.item.modelId + ":" + selectedItem.item.modelItemId
      );
    });
    return api;
  })
  .catch((e) => {
    console.log("LwAPI could not be initialized: ", e);
    return null;
  });

const exampleUrl = modelPathOnServer + "nist_ctc_02_asme1_nx800_rc.jt";

function ex_open() {
  const outputElement = document.getElementById(
    "output"
  ) as HTMLTextAreaElement;
  if (outputElement) {
    outputElement.value = "";
  }
  LwAPI?.openModel(exampleUrl);
}

function ex_getmodelviews() {
  LwAPI?.getModelViews().then(function (result) {
    const outputElement = document.getElementById(
      "output"
    ) as HTMLTextAreaElement;
    if (outputElement) {
      outputElement.value = JSON.stringify(result, null, " ");
    }
    result.forEach(function (view) {
      var optn = document.createElement("option");
      optn.textContent = view.name;
      optn.value = view.index.toString();
      const selectViewElement = document.getElementById("selectview");
      if (selectViewElement) {
        selectViewElement.appendChild(optn);
      }
    });
  });
}

function ex_setmodelview() {
  const selectElement = document.getElementById(
    "selectview"
  ) as HTMLSelectElement;
  if (selectElement) {
    LwAPI?.setModelView(parseInt(selectElement.value));
  }
}

// Bind functions to buttons
document.getElementById("open")?.addEventListener("click", async () => {
  await apiReady;
  ex_open();
});
document.getElementById("getmodelviews")?.addEventListener("click", async () => {
  await apiReady;
  ex_getmodelviews();
});
document.getElementById("selectview")?.addEventListener("change", async () => {
  await apiReady;
  ex_setmodelview();
});
